<div class="color-code-picker" [class.color-code-picker--field]="variant === 'field'"
    [class.color-code-picker--inline]="variant === 'inline'">
    <button type="button"
        class="color-code-picker__trigger"
        (click)="openColorPalette($event)">
        <span class="color-code-picker__swatch"
            [style.background-color]="displayColor"></span>
        <span class="color-code-picker__hex">{{ displayColor | uppercase }}</span>
        <i class="fa-regular fa-chevron-down color-code-picker__caret" *ngIf="showCaret"></i>
    </button>

    <p-overlayPanel #colorPalette
        [dismissable]="true"
        [showCloseIcon]="false"
        styleClass="tech-color-palette-op"
        appendTo="body"
        (onHide)="onPanelHide()">
        <div class="tech-color-palette" *ngIf="!showCustomPicker">
            <button type="button"
                class="tech-color-palette__swatch"
                *ngFor="let preset of presetColors"
                [style.background-color]="preset"
                [class.is-selected]="isColorSelected(preset)"
                [attr.aria-label]="preset"
                (click)="selectPresetColor(preset)">
                <i class="fa-solid fa-check" *ngIf="isColorSelected(preset)"></i>
            </button>

            <button type="button"
                class="tech-color-palette__add"
                [pTooltip]="'Custom color'"
                tooltipPosition="top"
                (click)="openCustomColorPicker($event)">
                <i class="fa-regular fa-plus"></i>
            </button>
        </div>

        <div class="tech-color-palette__custom" *ngIf="showCustomPicker" (click)="$event.stopPropagation()">
            <button type="button" class="tech-color-palette__back" (click)="showCustomPicker = false">
                <i class="fa-regular fa-arrow-left"></i>
                Back
            </button>
            <p-colorPicker
                [(ngModel)]="customColor"
                [ngModelOptions]="{standalone: true}"
                format="hex"
                [inline]="true">
            </p-colorPicker>
            <button type="button" class="tech-color-palette__save" (click)="applyCustomColor()">
                {{ saveLabel || 'Save' }}
            </button>
        </div>
    </p-overlayPanel>
</div>
